export function teamAssociationServiceMethods() {
    return {
        async getRelatedTeams(id, params = {}) {
            try {
                const response = await this.api.getRelatedTeams(id, params);
                return {
                    success: true,
                    data: response.data || [],
                    pagination: response.pagination || {},
                    message: response.message,
                };
            } catch (error) {
                throw this._handleError(error, 'Failed to fetch related teams');
            }
        },
        async getExecutionPlan(id) {
            try {
                const response = await this.api.getExecutionPlan(id);
                return { success: true, data: response.data || [], message: response.message };
            } catch (error) {
                throw this._handleError(error, 'Failed to fetch execution plan');
            }
        },
        async updateExecutionPlan(id, body) {
            try {
                const response = await this.api.updateExecutionPlan(id, body);
                return { success: true, data: response.data, message: response.message };
            } catch (error) {
                throw this._handleError(error, 'Failed to update execution plan');
            }
        },
        async addTeams(id, teamIdsOrBody) {
            try {
                const response = await this.api.addTeams(id, teamIdsOrBody);
                return {
                    success: true,
                    data: response.data,
                    message: response.message,
                };
            } catch (error) {
                throw this._handleError(error, 'Failed to link teams');
            }
        },
        async copyTeamsFromLinked(id) {
            try {
                const response = await this.api.copyTeamsFromLinked(id);
                return {
                    success: true,
                    data: response.data,
                    addedSources: response.addedSources || [],
                    message: response.message,
                };
            } catch (error) {
                throw this._handleError(error, 'Failed to copy teams');
            }
        },
        async removeTeam(id, teamId) {
            try {
                const response = await this.api.removeTeam(id, teamId);
                return {
                    success: true,
                    data: response.data,
                    message: response.message,
                };
            } catch (error) {
                throw this._handleError(error, 'Failed to unlink team');
            }
        },
        async updateAssignment(id, assignmentId, assignmentOrMembers) {
            try {
                const response = await this.api.updateAssignment(id, assignmentId, assignmentOrMembers);
                return { success: true, data: response.data, message: response.message };
            } catch (error) {
                throw this._handleError(error, 'Failed to update assignment');
            }
        },
        async removeAssignment(id, assignmentId) {
            try {
                const response = await this.api.removeAssignment(id, assignmentId);
                return { success: true, data: response.data, message: response.message };
            } catch (error) {
                throw this._handleError(error, 'Failed to unlink assignment');
            }
        },
        async getRrLinkCandidates(id, params = {}) {
            try {
                const response = await this.api.getRrLinkCandidates(id, params);
                return {
                    success: true,
                    data: response.data || [],
                    pagination: response.pagination || {},
                    message: response.message,
                };
            } catch (error) {
                throw this._handleError(error, 'Failed to fetch R&R sources');
            }
        },
        async addDutyDefinitions(id, body) {
            try {
                const response = await this.api.addDutyDefinitions(id, body);
                return { success: true, data: response.data, message: response.message };
            } catch (error) {
                throw this._handleError(error, 'Failed to link duty definitions');
            }
        },
        async createAndLinkDutyDefinition(id, body) {
            try {
                const response = await this.api.createAndLinkDutyDefinition(id, body);
                return { success: true, data: response.data, message: response.message };
            } catch (error) {
                throw this._handleError(error, 'Failed to create duty definition');
            }
        },
        async removeDutyDefinition(id, dutyDefinitionId) {
            try {
                const response = await this.api.removeDutyDefinition(id, dutyDefinitionId);
                return { success: true, data: response.data, message: response.message };
            } catch (error) {
                throw this._handleError(error, 'Failed to unlink duty definition');
            }
        },
    };
}
